<ng-container *ngIf="!isMobileDevice() || !subPageName; else mobileForms">
	<section *ngIf="!forms" class="zk-flex zk-justify-center zk-py-5">
		<freud-loader size="sm" [bgColor]="false"></freud-loader>
	</section>
	<ng-container *ngIf="forms">
		<section class="zk-flex zk-flex-wrap zk-mb-6" *ngIf="!showBillingCard()">
			<div class="zk-w-full">
				<h1 class="billing-card-title zk-text-base zk-font-thick zk-mb-4">
					{{ 'MY_ACCOUNT.FINANCIAL.BILLING_CARD.TITLE' | translate }}
				</h1>
			</div>

			<!-- Column 1 -->
			<div class="zk-w-full lg:zk-w-6/12 xl:zk-w-6/12 lg:zk-pr-4 zk-mb-6">
				<app-billing-card
					[selected]="billingTypeSelected == billingTypes.Legal"
					[stage]="getLegalStatus()"
					[active]="professionalPerson?.type === 'legal'"
					[businessType]="'legal'"
					[activationDate]="getBillingTypeStartAt(billingTypes.Legal)"
					[inactivationDate]="professionalPerson?.lastLegalPersonPeriod?.endsAt"
					(cardSelected)="selectLegalEntityBillingCard()"
					(cancel)="
						openDialogCancellation(cancellationDialogTypes.RollbackToNatural)
					"
				>
				</app-billing-card>
			</div>

			<!-- Column 2 -->
			<div
				class="zk-w-full lg:zk-w-6/12 xl:zk-w-6/12 lg:zk-pl-4 zk-mb-6"
				*ngIf="naturalPersonCardEnabled()"
			>
				<app-billing-card
					[selected]="billingTypeSelected == billingTypes.Natural"
					[active]="professionalPerson?.type === 'natural'"
					[businessType]="'natural'"
					[stage]="getNaturalStatus()"
					[activationDate]="getBillingTypeStartAt(billingTypes.Natural)"
					[inactivationDate]="
						professionalPerson?.lastNaturalPersonPeriod?.endsAt
					"
					(cardSelected)="selectNaturalBillingCard()"
					(cancel)="
						openDialogCancellation(cancellationDialogTypes.RollbackToLegal)
					"
					(cardActivated)="openChangeBillingTypeDialog(billingTypes.Natural)"
				>
				</app-billing-card>
			</div>
		</section>

		<ng-container>
			<ng-container *ngTemplateOutlet="desktopFormContainer"> </ng-container>
		</ng-container>
	</ng-container>
</ng-container>

<ng-template #mobileForms>
	<div [ngSwitch]="subPageName">
		<app-billing-data
			(triggerValidation)="setPaymentMethodUpdateResponse()"
			(waitingIdwallResponse)="isIdwallCalled($event)"
			*ngSwitchCase="'DATA'"
			[showTitle]="!isMobileDevice()"
			[formParams]="getCurrentFormData()"
			[professionalPerson]="professionalPerson"
			(cpnjValidationTrigger)="getProfessionalFinancial($event)"
		>
		</app-billing-data>

		<app-billing-address
			*ngSwitchCase="'ADDRESS'"
			[showTitle]="!isMobileDevice()"
			[formParams]="getCurrentFormAddress()"
		>
		</app-billing-address>

		<app-billing-documents
			*ngSwitchCase="'DOCUMENTS'"
			[user]="user"
			[professionalPerson]="professionalPerson"
			[showRequiredFiles]="showRequiredFiles"
			[disabled]="getCurrentFormData()?.disabled"
			(fileSaved)="onAddedDocument()"
			[billingType]="billingTypeSelected"
		>
		</app-billing-documents>
	</div>

	<app-alert-label
		*ngIf="showAlertLabel"
		[changedFinancialTypeAt]="timeRange.paymentAccountUpdateAt"
	></app-alert-label>

	<app-alert-bank-label [timeRange]="timeRange"></app-alert-bank-label>
	<app-alert-info-status [timeRange]="timeRange"></app-alert-info-status>
	<app-bank-data
		*ngIf="user && subPageName == 'BANK_DATA'"
		[allowUpdatePaymentMethod]="allowPaymentUpdate"
		[allowSavePaymentData]="allowSavePaymentData"
		[paymentAccount]="user.paymentAccount"
		[professionalPerson]="professionalPerson"
		(formGroup)="onLoadBankForm($event)"
	></app-bank-data>

	<div
		class="save-button zk-fixed zk-inset-x-0 zk-bottom-0"
		*ngIf="subPageName != 'DOCUMENTS'"
	>
		<div class="zk-w-full zk-px-5 zk-py-3 zk-bg-white">
			<button
				zk-button
				zkButtonColor="primary"
				[zkButtonLoading]="isSaving"
				[disabled]="!mobileFormIsDisabled()"
				zkButtonSize="medium"
				[class.disabled-field]="allowPaymentUpdate"
				(click)="saveMobileForm()"
			>
				{{ 'MY_ACCOUNT.FINANCIAL.SAVE' | translate }}
			</button>
		</div>
	</div>
</ng-template>

<ng-template #desktopFormContainer>
	<section
		class="zk-flex zk-w-full zk-flex-wrap zk-mb-4"
		*ngIf="hasStripeAccountConnected()"
	>
		<freud-button
			class="btnStripeCustomerPortal"
			color="primary"
			(click)="goToStripeCustomerPortal()"
		>
			<div class="zk-flex zk-gap-2 zk-w-full zk-justify-center zk-items-center">
				<span
					class="
						freud-icon freud-icon-md freud-icon-credit-card
						credit-card-icon
					"
				></span>
				<p class="text-stripe-customer-portal">
					{{ 'MY_ACCOUNT.FINANCIAL.PAYMENT_METHOD.TITLE' | translate }}
				</p>
			</div>
		</freud-button>
	</section>

	<section
		class="zk-flex zk-w-full zk-flex-wrap zk-mb-4"
		*ngIf="professionalPerson?.type"
	>
		<!-- Column 1 -->
		<div
			class="zk-w-full lg:zk-w-12/12 xl:zk-w-12/12 lg:zk-pr-4"
			*ngIf="billingTypeSelected == billingTypes.Legal"
		>
			<app-billing-data
				(triggerValidation)="setPaymentMethodUpdateResponse()"
				[formParams]="getCurrentFormData()"
				[professionalPerson]="professionalPerson"
				(waitingIdwallResponse)="isIdwallCalled($event)"
				(cpnjValidationTrigger)="getProfessionalFinancial($event)"
			>
			</app-billing-data>
		</div>

		<div
			class="zk-w-full lg:zk-w-6/12 xl:zk-w-6/12 lg:zk-pr-4"
			*ngIf="billingTypeSelected == billingTypes.Natural"
		>
			<app-billing-data
				[formParams]="getCurrentFormData()"
				[professionalPerson]="professionalPerson"
			>
			</app-billing-data>
		</div>

		<!-- Column 2 - Only show if its a natural person-->
		<div
			class="zk-w-full lg:zk-w-6/12 xl:zk-w-6/12 lg:zk-pl-4"
			*ngIf="billingTypeSelected == billingTypes.Natural"
		>
			<app-billing-address [formParams]="getCurrentFormAddress()">
			</app-billing-address>
		</div>

		<div class="zk-w-full" *ngIf="billingTypeSelected == billingTypes.Natural">
			<h1
				class="
					zk-text-base zk-mt-8 zk-mb-4 zk-w-full
					text-color-2
					zk-font-thick
				"
			>
				{{
					'MY_ACCOUNT.FINANCIAL.BILLING_DOCUMENTS.TITLE.' +
						professionalPerson.type.toUpperCase() | translate
				}}
			</h1>

			<app-billing-documents
				[user]="user"
				[professionalPerson]="professionalPerson"
				[showRequiredFiles]="showRequiredFiles"
				[disabled]="getCurrentFormData()?.disabled"
				[billingType]="billingTypeSelected"
				(fileSaved)="onAddedDocument()"
			>
			</app-billing-documents>
		</div>
	</section>

	<section class="zk-flex zk-flex-wrap zk-mb-12">
		<div class="zk-w-full zk-mb-4">
			<h1
				class="
					zk-text-base zk-mb-2 zk-w-full
					text-color-2
					bank-data-title
					zk-flex
				"
			>
				<span class="zk-font-thick zk-pr-2">{{
					'MY_ACCOUNT.FINANCIAL.BANK_DATA.TITLE' | translate
				}}</span>
				<zk-tooltip
					theme="default"
					tooltipMessage="{{
						'MY_ACCOUNT.FINANCIAL.BANK_DATA.LABEL' | translate
					}}"
				>
					<img
						[alt]="'MY_ACCOUNT.FINANCIAL.BANK_DATA.TITLE' | translate"
						class="zk--mt-2 lock-icon"
						src="/assets/icons/my-account/lock.svg"
					/>
				</zk-tooltip>
			</h1>
			<p class="zk-text-xs text-color-2">
				{{ 'MY_ACCOUNT.FINANCIAL.BANK_DATA.DESCRIPTION' | translate }}
			</p>
		</div>
		<app-alert-label
			*ngIf="showAlertLabel"
			[changedFinancialTypeAt]="timeRange.paymentAccountUpdateAt"
		></app-alert-label>
		<app-alert-bank-label></app-alert-bank-label>
		<app-alert-info-status class="bank-validation-info"></app-alert-info-status>

		<app-bank-data
			*ngIf="user"
			[allowUpdatePaymentMethod]="allowPaymentUpdate"
			[professionalPerson]="professionalPerson"
			[paymentAccount]="user.paymentAccount"
			(formGroup)="onLoadBankForm($event)"
		></app-bank-data>
	</section>

	<section class="form-actions zk-flex zk-flex-wrap">
		<div class="zk-w-full">
			<div
				class="
					lg:zk-w-42
					xl:zk-w-42
					lg:zk-float-right
					xl:zk-float-right
					lg:zk-ml-5
					xl:zk-ml-5
					sm:zk-mb-4
				"
			>
				<button
					zk-button
					zkButtonColor="primary"
					[zkButtonLoading]="isSaving"
					zkButtonSize="medium"
					(click)="saveForm()"
					[class.disabled-field]="allowPaymentUpdate"
					[disabled]="!formIsChanged()"
				>
					{{ 'MY_ACCOUNT.FINANCIAL.SAVE' | translate }}
				</button>
			</div>

			<div class="lg:zk-w-42 xl:zk-w-42 lg:zk-float-right xl:zk-float-right">
				<button
					zk-button
					zkButtonColor="secondary"
					[disabled]="!formIsChanged()"
					zkButtonSize="medium"
					[class.disabled-field]="allowPaymentUpdate"
					(click)="openDialogCancellation(cancellationDialogTypes.Cancel)"
				>
					{{ 'MY_ACCOUNT.FINANCIAL.CANCEL' | translate }}
				</button>
			</div>
		</div>
	</section>
</ng-template>

<zk-dialog class="cancellation-dialog" [(isOpen)]="cancellationDialog.isOpen">
	<ng-container zk-dialog-header>
		{{ 'MY_ACCOUNT.FINANCIAL.MODAL_CANCEL.TITLE' | translate }}
	</ng-container>
	<ng-container zk-dialog-body>
		<p
			class="
				text-color-2
				zk-text-base zk-font-thick zk-whitespace-pre-line zk-mb-4
			"
		>
			<ng-container [ngSwitch]="cancellationDialog.type">
				<ng-container *ngSwitchCase="cancellationDialogTypes.Cancel">
					{{ 'MY_ACCOUNT.FINANCIAL.MODAL_CANCEL.SUBTITLE' | translate }}
				</ng-container>
				<ng-container *ngSwitchCase="cancellationDialogTypes.RollbackToNatural">
					{{
						'MY_ACCOUNT.FINANCIAL.MODAL_CANCEL.SUBTITLE_ROLLBACK_TO_NATURAL'
							| translate
					}}
				</ng-container>
				<ng-container *ngSwitchCase="cancellationDialogTypes.RollbackToLegal">
					{{
						'MY_ACCOUNT.FINANCIAL.MODAL_CANCEL.SUBTITLE_ROLLBACK_TO_LEGAL'
							| translate
					}}
				</ng-container>
				<ng-container
					*ngSwitchCase="cancellationDialogTypes.RollbackLegalToBlank"
				>
					{{
						'MY_ACCOUNT.FINANCIAL.MODAL_CANCEL.SUBTITLE_ROLLBACK_LEGAL_TO_BLANK'
							| translate
					}}
				</ng-container>
				<ng-container
					*ngSwitchCase="cancellationDialogTypes.RollbackNaturalToBlank"
				>
					{{
						'MY_ACCOUNT.FINANCIAL.MODAL_CANCEL.SUBTITLE_ROLLBACK_NATURAL_TO_BLANK'
							| translate
					}}
				</ng-container>
			</ng-container>
		</p>

		<p
			class="text-color-2 zk-text-sm"
			*ngIf="cancellationDialog.showDescription"
		>
			<ng-container [ngSwitch]="cancellationDialog.type">
				<ng-container *ngSwitchCase="cancellationDialogTypes.RollbackToNatural">
					{{
						'MY_ACCOUNT.FINANCIAL.MODAL_CANCEL.DESCRIPTION_ROLLBACK_TO_NATURAL'
							| translate
					}}
				</ng-container>
				<ng-container *ngSwitchCase="cancellationDialogTypes.RollbackToLegal">
					{{
						'MY_ACCOUNT.FINANCIAL.MODAL_CANCEL.DESCRIPTION_ROLLBACK_TO_LEGAL'
							| translate
					}}
				</ng-container>
				<ng-container
					*ngSwitchCase="cancellationDialogTypes.RollbackNaturalToBlank"
				>
					{{
						'MY_ACCOUNT.FINANCIAL.MODAL_CANCEL.DESCRIPTION_ROLLBACK_FIRST_CONFIGURATION'
							| translate
					}}
				</ng-container>
				<ng-container
					*ngSwitchCase="cancellationDialogTypes.RollbackLegalToBlank"
				>
					{{
						'MY_ACCOUNT.FINANCIAL.MODAL_CANCEL.DESCRIPTION_ROLLBACK_FIRST_CONFIGURATION'
							| translate
					}}
				</ng-container>
			</ng-container>
		</p>
	</ng-container>
	<ng-container zk-dialog-footer>
		<div class="zk-flex zk-items-center zk-justify-center zk-w-full zk-px-4">
			<div class="zk-w-32 zk-mr-2">
				<button
					zk-button
					zkButtonColor="secondary"
					type="button"
					zkButtonSize="{{ isMobileDevice() ? 'small' : 'medium' }}"
					[zkButtonLoading]="cancellationDialog.isLoading"
					(click)="onRequestCancellation()"
				>
					{{ 'MY_ACCOUNT.FINANCIAL.YES' | translate }}
				</button>
			</div>
			<div class="zk-w-32 zk-ml-2">
				<button
					zk-button
					type="button"
					zkButtonSize="{{ isMobileDevice() ? 'small' : 'medium' }}"
					(click)="cancellationDialog.isOpen = false"
				>
					{{ 'MY_ACCOUNT.FINANCIAL.NO' | translate }}
				</button>
			</div>
		</div>
	</ng-container>
</zk-dialog>

<zk-dialog
	class="update-confirmation-dialog"
	[(isOpen)]="updateConfirmationDialog.isOpen"
>
	<ng-container zk-dialog-header>
		{{ 'MY_ACCOUNT.FINANCIAL.MODAL_BANK_DATA.TITLE' | translate }}
	</ng-container>
	<ng-container zk-dialog-body>
		<p
			class="
				text-color-2
				zk-text-base zk-font-thick zk-whitespace-pre-line zk-mb-4
			"
		>
			{{ 'MY_ACCOUNT.FINANCIAL.MODAL_BANK_DATA.SUBTITLE' | translate }}
		</p>

		<p class="text-color-2 zk-text-sm">
			{{ 'MY_ACCOUNT.FINANCIAL.MODAL_BANK_DATA.DETAILS_TITLE' | translate }}
		</p>
	</ng-container>
	<ng-container zk-dialog-footer>
		<div class="zk-flex zk-items-center zk-justify-center zk-w-full zk-px-4">
			<div class="zk-w-32 zk-mr-2">
				<button
					zk-button
					zkButtonColor="secondary"
					type="button"
					zkButtonSize="{{ isMobileDevice() ? 'small' : 'medium' }}"
					(click)="updateConfirmationDialog.isOpen = false"
				>
					{{ 'MY_ACCOUNT.FINANCIAL.NO' | translate }}
				</button>
			</div>
			<div class="zk-w-32 zk-ml-2">
				<button
					zk-button
					type="button"
					zkButtonSize="{{ isMobileDevice() ? 'small' : 'medium' }}"
					(click)="onConfirmedUpdate()"
				>
					{{ 'MY_ACCOUNT.FINANCIAL.YES' | translate }}
				</button>
			</div>
		</div>
	</ng-container>
</zk-dialog>
